module.exports = __webpack_public_path__ + "img/previous.0826631a.svg";